export class CancelledError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'CancelledError'
  }
}
